import Register from '@/pages/Register'

export default {
  path: '/register',
  name: 'register',
  component: Register
}



// WEBPACK FOOTER //
// ./src/router/register.js